import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/time';

// ------- SAGA ------ //

function changeStatusTimer(state, action) {
  const { status } = action.payload;
  state.response = status;
}

const timerPassCoopeuch = createAction('timerPassCoopeuch');


const timerReducer = createSlice({
  name: 'Timer',
  initialState,
  reducers: {
    changeStatusTimer,
  },
});

export const timerActions = {
  ...timerReducer.actions,
  timerPassCoopeuch
};

export default timerReducer.reducer;
